import React from 'react';
import SortButton from '../SortButton';
import { ButtonBlock } from '../DishListPage/DishListPageStyles';

const SortButtonCroup = React.memo(({ onClickSort, arrayForSort, nutrient = 'calories' }) => {
  return (
    <React.Fragment>
      <ButtonBlock>
        <SortButton
          onClickSort={onClickSort}
          isFromMoreToLess={false}
          nutrient={nutrient}
          iconName="sort numeric down"
          arrayForSort={arrayForSort}
        />
        <SortButton
          onClickSort={onClickSort}
          isFromMoreToLess
          nutrient={nutrient}
          iconName="sort numeric up"
          arrayForSort={arrayForSort}
        />
      </ButtonBlock>
    </React.Fragment>
  );
});

export default SortButtonCroup;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/SortButtonGroup/index.jsx